export const parseSellingPropertyCoordinates = (value = '') => {
  const trimmedValue = String(value || '').trim();
  if (!trimmedValue) {
    return null;
  }

  const parts = trimmedValue.split(',').map((entry) => entry.trim()).filter(Boolean);
  if (parts.length !== 2) {
    return null;
  }

  const [latitudeText, longitudeText] = parts;
  const latitude = Number(latitudeText);
  const longitude = Number(longitudeText);

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return null;
  }

  return {
    coordinates: `${latitude}, ${longitude}`,
    latitude,
    longitude
  };
};
